// import 'antd/dist/antd.css';
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import { Col, Avatar, Row, Typography } from 'antd';
// import { FormattedMessage } from 'react-intl';

import doctor from '../../Images/doctor.png';
import lab from '../../Images/lab1.png';
import health from '../../Images/Health.png';
import hospital from '../../Images/Hospital.png';
import telemedicine from '../../Images/Telemedicine.png';
import pharmacies from '../../Images/Pharmacies.png';
import google from '../../Images/google.png';
import apple from '../../Images/apple.png';
// import { HeaderText, BodyTextHome } from '../CommonText';
// import messages from './messages';
import './style.css';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const Responsiveheader = ({applyViewportChange }) => {
    const [viewportWidth, setViewportWidth] = useState(0);
    
    // Throttle the resize event and set the viewport width
    const saveViewportDimensions = useCallback(
        throttle(() => {
            setViewportWidth(window.innerWidth);
        }, applyViewportChange),
        [applyViewportChange]
    );

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    useEffect(() => {
        saveViewportDimensions();
        window.addEventListener('resize', saveViewportDimensions);

        return () => {
            window.removeEventListener('resize', saveViewportDimensions);
        };
    }, [saveViewportDimensions]);

    // if (viewportWidth <= mobileBreakPoint) {
    //     return <div />; // Nothing for small screens
    // }    

    // Render content for larger screens
    return (
        <div>
            {/* Heading section 1 */}
            <Row>
                <Col span={10} style={{ marginLeft: '3%', marginTop: `${(parseInt(viewportWidth/100))-3}%` }}>
                    <Col span={24} style={{ textAlign: 'left' }}>
                        {/* <div className="subHeading1"> */}
                        {/* <FormattedMessage {...messages.doctorClickAway} /> */}
                        {/* <HeaderText text={`${langdata.doctorClickAway ? langdata.doctorClickAway : 'The doctors are now just a click away'}`} /> */}
                        <Typography
                            style={{
                                fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '20px' : '30px',
                                // fontFamily: 'Roboto',
                                // fontWeight : 'bold',
                                color: '#828282',
                                textAlign:'justify'
                            }}
                        >{`${langdata.doctorClickAway ? langdata.doctorClickAway : 'The doctors are now just a click away'}`}
                        </Typography>
                        {/* </div> */}
                    </Col>
                    <Col span={24} style={{ textAlign: 'left' , marginLeft:'5%'}}>
                        {/* <div className="subContent"> */}

                        {/* <FormattedMessage {...messages.doctorClickAwayContent} /> */}
                        {/* <BodyTextHome text={`${langdata.doctorClickAwayContent ? langdata.doctorClickAwayContent : 'QuikDr Mobile app that lets you book appointments and get quick medical advice over video calls or in hospital from a specialist anytime, anywhere. Gets your medical prescriptions in real-time on your mobile phone. Avail ambulance facility at a single click and much more..'}`} /> */}
                        <Typography
                            style={{
                                fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '10px' : '20px',
                                // fontFamily: 'Roboto',
                                color: '#828282',
                                textAlign:'justify'
                            }}
                        >{`${langdata.doctorClickAwayContent ? langdata.doctorClickAwayContent : 'QuikDr Mobile app that lets you book appointments and get quick medical advice over video calls or in hospital from a specialist anytime, anywhere. Gets your medical prescriptions in real-time on your mobile phone. Avail ambulance facility at a single click and much more..'}`}
                        </Typography>
                        {/* </div> */}


                        <div>
                            <Row>
                                <Col
                                    span={12} style={{ cursor: 'pointer' }} onClick={() => {
                                        window.open('https://play.google.com/store/apps/details?id=com.quikdr.app');
                                    }}
                                >
                                    <img style={{ marginTop: '15px', width: parseInt(viewportWidth/100) > 9 ? '200px' : parseInt(viewportWidth/100) > 7 ? '150px' : '70px' }} src={google} />
                                </Col>
                                <Col
                                    span={12} style={{ cursor: 'pointer' }} onClick={() => {
                                        window.open('https://apps.apple.com/us/app/id1512292509');
                                    }}
                                >
                                    <img style={{ marginTop: '15px', width: parseInt(viewportWidth/100) > 9 ? '200px' : parseInt(viewportWidth/100) > 7 ? '150px' : '70px' }} src={apple} />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Col>
            </Row>
            {/* Heading section 2*/}
            <Row justify={'end'}>
                <Col span={10} style={{marginTop:`${(parseInt(viewportWidth/100))+2}%`}}>
                    <Col span={24} style={{ textAlign: 'left'}}>
                        {/* <div className="subHeading1">
                            <HeaderText text={`${langdata.quikdrBrings ? langdata.quikdrBrings : 'QuikDr brings doctors and patients closer'}`} />
                        </div> */}
                        <Typography
                            style={{
                                fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '20px' : '30px',
                                // fontFamily: 'Roboto',
                                // fontWeight : 'bold',
                                color: '#828282',
                                textAlign:'justify',
                                marginRight:'10%'
                            }}
                        >{`${langdata.quikdrBrings ? langdata.quikdrBrings : 'QuikDr brings doctors and patients closer'}`}</Typography>
                    </Col>
                    <Col span={24} style={{ textAlign: 'left', marginLeft:'5%'}}>
                        {/* <div className="subContent">
                            <BodyTextHome text={`${langdata.quikdrBringsContent ? langdata.quikdrBringsContent : 'Distance does not matter anymore. Our online consultation service eliminates the need to travel to see your doctor and we will save your precious time. You can get professional medical advice over your phone/laptop through our app- all without having to leave your home or workplace.'}`} />
                        </div> */}
                        <Typography
                            style={{
                                fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '10px' : '20px',
                                // fontFamily: 'Roboto',
                                color: '#828282',
                                textAlign:'justify',
                                marginRight:'10%'
                            }}
                        >{`${langdata.quikdrBringsContent ? langdata.quikdrBringsContent : 'Distance does not matter anymore. Our online consultation service eliminates the need to travel to see your doctor and we will save your precious time. You can get professional medical advice over your phone/laptop through our app- all without having to leave your home or workplace.'}`}
                        </Typography>

                    </Col>
                </Col>
            </Row>
            {/* Heading section 3 */}
            <Row>
                <Col span={10} style={{ marginLeft: '3%', marginTop: parseInt(viewportWidth/100) <=10 ? `${(parseInt(viewportWidth/100))+25}%` : `${(parseInt(viewportWidth/100))+7}%` }}>
                    <Col xxl={{ span: 24 }} style={{ textAlign: 'left' }}>
                        {/* <div className="subHeading1">
                            <HeaderText text={`${langdata.kiosk ? langdata.kiosk : 'KIOSK'}`} />

                        </div> */}
                        <Typography
                            style={{
                                fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '20px' : '30px',
                                // fontFamily: 'Roboto',
                                // fontWeight : 'bold',
                                color: '#828282',
                                textAlign:'justify'
                            }}
                        >{`${langdata.kiosk ? langdata.kiosk : 'KIOSK'}`}
                        </Typography>
                    </Col>
                    <Col span={24} style={{ textAlign: 'left', marginLeft:'4%'}}>
                        {/* <div className="subContent">
                            <BodyTextHome text={`${langdata.kioskContent ? langdata.kioskContent : 'Why waiting in long queues to consult a doctor? You can book appointments from the QuikDr Kiosk stations at partner hospitals just by entering your mobile number.'}`} />

                        </div> */}
                        <Typography
                            style={{
                                fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '10px' : '20px',
                                // fontFamily: 'Roboto',
                                color: '#828282',
                                textAlign:'justify'
                            }}
                        >{`${langdata.kioskContent ? langdata.kioskContent : 'Why waiting in long queues to consult a doctor? You can book appointments from the QuikDr Kiosk stations at partner hospitals just by entering your mobile number.'}`}
                        </Typography>
                    </Col>
                </Col>
            </Row>
            {/* Heading section 4*/}
            <Row>
                <Col span={24} style={{marginTop: parseInt(viewportWidth/100) <=10 ? `${(parseInt(viewportWidth/100))+25}%` : `${(parseInt(viewportWidth/100))+12}%`}}>
                    <Row>
                        <Col span={6}>&nbsp;</Col>
                        <Col span={12} style={{}}>
                            {/* <Row>
                            <Col span={24} style={{ color: '#333', fontSize: '36px', fontFamily: 'Roboto', textAlign: 'center', marginBottom: '10px' }}> */}
                            {/* <FormattedMessage {...messages.vision} />*/}
                            {/* <HeaderText text={`${langdata.vision ? langdata.vision : 'Our Vision'}`} /> */}
                            <Typography
                                style={{
                                    fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '26px' : '36px',
                                    // fontFamily: 'Roboto',
                                    // fontWeight : 'bold',
                                    color: '#828282',
                                    justifyContent:'center', display:'flex',
                                    textAlign:'justify'
                                }}
                            >{`${langdata.vision ? langdata.vision : 'Our Vision'}`}
                            </Typography>

                            {/* </Col> */}
                            {/* <Col span={24} style={{ color: '#555', fontSize: '21px', fontFamily: 'Roboto', marginBottom: '10px' }}> */}
                            {/* <FormattedMessage {...messages.visionContent} /> */}
                            {/* <BodyTextHome text={`${langdata.visionContent ? langdata.visionContent : 'We want to become the most trusted healthcare companion that you can relay on when quick medical advice is required. We will delight you with the quality healthcare at your fingertips round the clock.'}`} /> */}

                            <Typography
                                style={{
                                    fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '11px' : '21px',
                                    // fontFamily: 'Roboto',
                                    color: '#828282',
                                    justifyContent:'center', display:'flex',
                                    textAlign:'justify'
                                }}
                            >{`${langdata.visionContent ? langdata.visionContent : 'We want to become the most trusted healthcare companion that you can relay on when quick medical advice is required. We will delight you with the quality healthcare at your fingertips round the clock.'}`}
                            </Typography>


                            {/* </Col> */}
                            {/* </Row> */}
                        </Col>

                        <Col span={6}>&nbsp;</Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                {/* Vision content*/}
                <Col span={24} style={{marginTop:'5%'}}>
                    <Row>
                        <Col span={1} style={{ textAlign: 'center' }}>&nbsp;</Col>

                        <Col span={7} style={{ textAlign: 'center' }}>
                            <Col span={24}>
                                <Avatar shape="square" size={80} icon="user" src={doctor} />
                            </Col>

                            <Col span={24}>
                                {/* <FormattedMessage {...messages.doctor} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '16px' : '26px',
                                        // fontFamily: 'Roboto',
                                        // fontWeight : 'bold',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.doctor ? langdata.doctor : 'Doctors'}`}
                                </Typography>
                            </Col>
                            <Col span={24}>
                                {/* <FormattedMessage {...messages.doctorContent} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '12px' :'18px',
                                        // fontFamily: 'Roboto',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.doctorContent ? langdata.doctorContent : 'Expert doctors provides quality remote consultation'}`}
                                </Typography>
                            </Col>
                        </Col>
                        <Col span={1} style={{ textAlign: 'center' }}>&nbsp;</Col>

                        <Col  span={7} style={{ textAlign: 'center' }}>
                            <Col span={24}>
                                <Avatar shape="square" size={78} icon="user" src={health} />
                            </Col>
                            <Col span={24}>
                                {/* <FormattedMessage {...messages.healthRecords} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '16px' : '26px',
                                        // fontFamily: 'Roboto',
                                        // fontWeight : 'bold',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.healthRecords ? langdata.healthRecords : 'Health Records'}`}
                                </Typography>
                            </Col>
                            <Col span={24} style={{ fontSize: '18px' }}>
                                {/* <FormattedMessage {...messages.healthrecordContent} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '12px' :'18px',
                                        // fontFamily: 'Roboto',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.healthrecordContent ? langdata.healthrecordContent : 'Centralised Health Records management system' }`}
                                </Typography>
                            </Col>
                        </Col>
                        <Col span={1} style={{ textAlign: 'center' }}>&nbsp;</Col>

                        <Col span={7} style={{ textAlign: 'center', marginLeft:'-1%' }}>
                            <Col span={24}>
                                <Avatar shape="square" size={80} icon="user" src={lab} />
                            </Col>
                            <Col span={24} style={{ fontSize: '26px' }}>
                                {/* <FormattedMessage {...messages.diagnostic} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '16px' : '26px',
                                        // fontFamily: 'Roboto',
                                        // fontWeight : 'bold',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.diagnostic ? langdata.diagnostic : 'Diagnostic labs'}`}
                                </Typography>
                            </Col>
                            <Col span={24} style={{ fontSize: '18px' }}>
                                {/* <FormattedMessage {...messages.diagnosticContent} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '12px' :'18px',
                                        // fontFamily: 'Roboto',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.diagnosticContent ? langdata.diagnosticContent : 'Quality diagnostic & telemedicine for a large population' }`}
                                </Typography>
                            </Col>
                        </Col>
                    </Row>
                </Col>
                <Col span={24} style={{marginTop:'5%'}}>
                    <Row>
                        <Col span={1} style={{ textAlign: 'center' }}>&nbsp;</Col>

                        <Col span={7} style={{ textAlign: 'center' }}>
                            <Col span={24} >
                                <Avatar shape="square" size={80} icon="user" src={telemedicine} />
                            </Col>
                            <Col span={24} style={{ fontSize: '26px' }}>
                                {/* <FormattedMessage {...messages.telemedicine} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '16px' : '26px',
                                        // fontFamily: 'Roboto',
                                        // fontWeight : 'bold',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.telemedicine ? langdata.telemedicine : 'Tele Medicine Centre' }`}
                                </Typography>
                            </Col>
                            <Col span={24} style={{ fontSize: '18px' }}>
                                {/* <FormattedMessage {...messages.telemedicineContent} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '12px' :'18px',
                                        // fontFamily: 'Roboto',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.telemedicineContent ? langdata.telemedicineContent : 'Accessible & Affordable setup providing remote diagnostics and consultations' }`}
                                </Typography>
                            </Col>
                        </Col>
                        <Col span={1} style={{ textAlign: 'center' }}>&nbsp;</Col>

                        <Col  span={7} style={{ textAlign: 'center' }}>
                            <Col span={24} >
                                <Avatar shape="square" size={77} icon="user" src={hospital} />
                            </Col>
                            <Col span={24} style={{ fontSize: '26px' }}>
                                {/* <FormattedMessage {...messages.hospital} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '16px' : '26px',
                                        // fontFamily: 'Roboto',
                                        // fontWeight : 'bold',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.hospital ? langdata.hospital : 'Hospitals' }`}
                                </Typography>
                            </Col>
                            <Col span={24} style={{ fontSize: '18px' }}>
                                {/* <FormattedMessage {...messages.hospitalContent} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '12px' :'18px',
                                        // fontFamily: 'Roboto',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.hospitalContent ? langdata.hospitalContent : 'More reach to remote areas option for primary. secondary & tertiary care'}`}
                                </Typography>
                            </Col>
                        </Col>
                        <Col span={1} style={{ textAlign: 'center' }}>&nbsp;</Col>

                        <Col  span={7} style={{ textAlign: 'center', marginLeft:'-1%' }}>
                            <Col span={24} >
                                <Avatar shape="square" size={80} icon="user" src={pharmacies} />
                            </Col>
                            <Col span={24} style={{ fontSize: '26px' }}>
                                {/* <FormattedMessage {...messages.pharmacies} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '16px' : '26px',
                                        // fontFamily: 'Roboto',
                                        // fontWeight : 'bold',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.pharmacies ? langdata.pharmacies : 'Pharmacies'}`}
                                </Typography>
                            </Col>
                            <Col span={24} style={{ fontSize: '18px' }}>
                                {/* <FormattedMessage {...messages.pharmaciesContent} /> */}
                                <Typography
                                    style={{
                                        fontSize: parseInt(viewportWidth/100)-3 <= 7 ? '12px' :'18px',
                                        // fontFamily: 'Roboto',
                                        color: '#828282',
                                        justifyContent:'center', display:'flex',
                                        textAlign:'justify'
                                    }}
                                >{`${langdata.pharmaciesContent ? langdata.pharmaciesContent : 'Make quality medicine & health products available for a large population'}`}
                                </Typography>
                            </Col>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

Responsiveheader.propTypes = {
    mobileBreakPoint: PropTypes.number,
    applyViewportChange: PropTypes.number,
};

Responsiveheader.defaultProps = {
    mobileBreakPoint: 772,
    applyViewportChange: 250,
};

export default Responsiveheader;
